import { Component, input, output } from '@angular/core';
import {
  ButtonModule,
  GridModule,
  ModalModule,
  SpinnerModule
} from '@coreui/angular';
import { REQ } from '../../models';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'smarsh-base-modal',
  standalone: true,
  imports: [ModalModule, ButtonModule, GridModule, SpinnerModule, CommonModule],
  templateUrl: './base-modal.component.html',
  styles: ''
})
export class BaseModalComponent {
  req = REQ;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  signalData = input.required<any>(); // Using any as it is generic
  showModal = input.required<boolean>();
  title = input.required<string>();
  isInValid = input.required<boolean>();
  actionButtonLabel = input.required<string>();
  onClose = output();
  onSave = output();

  closeModal() {
    this.onClose.emit();
  }

  onConfirm() {
    this.onSave.emit();
  }
}
